import request from './request'
// 轮播图

export function getBanner(data){
    let url = "/api/HomePage/GetBannerPaged";
    return request({
        url: url,
        method: 'get',
        params:data
    });
}

// 首页分类列表
export function GetHomeLabels(data){
    let url = "/api/Label/GetHomaPageSystemLabels";
    return request({
        url: url,
        method: "post",
        dataType: "json",
        data
    });
}

// 获取搜索页类目
export function GetSearchDir(data){
    let url = "/api/DirectoryCategory/GetSearchDir";
    return request({
        url: url,
        method: 'get',
        params:data
    });
}

// 获取搜索更多条件列表
export function GetDirs(data){
    let url = "/api/DirectoryCategory/GetSearchDirsList";
    return request({
        url: url,
        method: 'post',
        dataType: 'json',
        data
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/indexApi.js